// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51cde42b","867":"be4b4d4f"}[chunkId] + ".chunk.js";
};